<template>
  <div class="mx-3">
    <ScoreTable v-bind:quizID="quizCode" :externalFields="externalFields" />
    <TopQuizChat :quizID="quizID" :quizHost="quizHost" />
  </div>
</template>

<script>
import TopQuizChat from "@/components/TopQuizChat";
import ScoreTable from "@/components/ScoreTable";
export default {
  name: "Spectate",
  components: {
    ScoreTable,
    TopQuizChat
  },
  data() {
    return {
      quizCode: "",
      quizID: 0,
      surveys: [],
      answers: {},
      quizHost: null
    };
  },
  computed: {
    externalFields() {
      var fields = [];
      this.surveys.forEach(survey => {
        if (!survey.showInTable || survey.public != 1) {
          return;
        }

        fields.push({
          key: "ext_" + survey.id,
          label: survey.title,
          data: teamID => {
            if (!this.answers[survey.id]) {
              return null;
            }
            return this.answers[survey.id][teamID];
          }
        });
      });
      return fields;
    }
  },
  created() {
    this.quizCode = this.$route.params.quizID;

    this.$topquiz.on(this, "spectate_success", params => {
      this.quizID = params[0];
      this.quizHost = params[2];
      this.$topquiz.sendCommand("subscribe-meta", this.quizID);

      this.$topquiz.sendCommand("spectator_getSurveyData", this.quizID);
    });

    this.$topquiz.on(this, "spectator_getSurveyData_success", params => {
      this.surveys = params[0];

      this.$topquiz.sendCommand("spectator_getSurveyAnswers", this.quizID);
    });

    this.$topquiz.on(this, "questionAsked", params => {
      this.surveys.push(params[0]);
    });

    this.$topquiz.on(this, "questionListedChanged", params => {
      var question = params[0];
      this.surveys.forEach(survey => {
        if (survey.id == question.id) {
          survey.showInTable = question.showInTable;
        }
      });
    });

    this.$topquiz.on(this, "answerReceived", params => {
      this.addAnswer(params[0]);
    });

    this.$topquiz.on(this, "surveyBatchAnswer", params => {
      var answers = params[1];
      answers.forEach(a => {
        this.addAnswer(a);
      });
    });

    this.$topquiz.on(this, "spectator_getSurveyAnswers_success", params => {
      var answersByQuestion = params[0];
      Object.keys(answersByQuestion).forEach(key => {
        var answers = answersByQuestion[key];
        answers.forEach(teamAnswer => {
          this.addAnswer(teamAnswer);
        });
      });
    });
  },
  destroyed() {
    this.$topquiz.sendCommand("unsubscribe-meta", this.quizID);
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    addAnswer(answer) {
      if (!this.answers[answer.question_id]) {
        this.$set(this.answers, answer.question_id, {});
      }

      this.$set(
        this.answers[answer.question_id],
        answer.team_id,
        answer.answer
      );
    }
  }
};
</script>

<style scoped></style>
